// checkChatMessageDraft.js
'use strict';
import { CHAT_VIDEO_LENGTH_MAX } from '../RemoteConfigKeys.js';

import fetchMeBalance from '../action/fetchMeBalance.js';
import login from '../action/login.js';
import addvalue from '../action/addvalue.js';
import pushToastr from '../action/pushToastr.js';
import getMeData from '../selector/getMeData.js';
import getMeBalance from '../selector/getMeBalance.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getVideoDuration from '../resource/getVideoDuration.js';

export const Via = {
  CHAT_MESSAGE: 'chat-message',
  RESEND_CHAT_MESSAGE: 'resend-chat-message',
  REPLY_MESSAGE: 'reply-message',
};

/**
 * Check chat message draft
 * @kind action
 * @param {string} {text} - chat message text.
 * @param {object} {media} - chat message media.
 * @param {string} {sendVia} - action be triggered by.
 * @param {number} {replyPrice} - chat message reply price.
 * @return {Promise} Action promise.
 */
const checkChatMessageDraft =
  ({ text, media, sendVia, replyPrice }) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');
    if (!token) {
      dispatch(login());
      throw new Error('not authorized');
    }
    const hasPayload = !!text?.length || !!media?.fileBlob?.size;
    if (!hasPayload) {
      throw new Error('invalid payload');
    }
    if (text?.length > 600) {
      dispatch(
        pushToastr({
          textKey: 'caption_word_length_error',
          color: 'error',
        })
      );
      throw new Error('text too long');
    }
    const hasBalance = getMeData(getState(), 'hasBalance');
    if (!hasBalance) {
      await dispatch(fetchMeBalance());
    }
    const meBalance = getMeBalance(getState());
    const hasEnoughBalance = meBalance >= replyPrice;
    if (!hasEnoughBalance) {
      dispatch(addvalue({ via: sendVia }));
      dispatch(
        pushToastr({
          textKey: 'alert_insufficient_funds',
          color: 'error',
        })
      );
      throw new Error('balance not enough');
    }
    if (media) {
      const isVideo = /^video/i.test(media.type);
      if (isVideo) {
        const maxDuration = getRemoteConfigData(
          getState(),
          CHAT_VIDEO_LENGTH_MAX
        );
        const duration = await getVideoDuration({ file: media.fileBlob });
        if (duration > maxDuration || !duration) {
          dispatch(
            pushToastr({
              textKey: 'uploader_video_longer_error',
              textKeyOption: [maxDuration / 60],
              color: 'error',
            })
          );
          throw new Error('invalid duration');
        }
      }
    }
  };

export default checkChatMessageDraft;
